module.exports = __webpack_public_path__ + "img/hella_1000A.3e9288bd.png";